// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.spotify-connect-container {
    background: #111111;
    height: 100vh;
    justify-content: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
}

.spotify-connect-button{
    margin-top: 60px;
    background: #1CD66A;
    font-weight: bold;
    font-size: 14px;
    width: 300px;
    border: none;
    padding: 14px;
    border-radius: 24px;
    cursor: pointer;
    transition: background 0.3s;
}`, "",{"version":3,"sources":["webpack://./src/styles/spotify_connect.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,2BAA2B;AAC/B","sourcesContent":[".spotify-connect-container {\n    background: #111111;\n    height: 100vh;\n    justify-content: center;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 20px;\n}\n\n.spotify-connect-button{\n    margin-top: 60px;\n    background: #1CD66A;\n    font-weight: bold;\n    font-size: 14px;\n    width: 300px;\n    border: none;\n    padding: 14px;\n    border-radius: 24px;\n    cursor: pointer;\n    transition: background 0.3s;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
